import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden bg-white" data-id="element-160">
      <div className="container mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-12 items-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-xl z-10" data-id="element-162">
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-tight text-dark mb-6" data-id="element-163">
            Бездоганний стиль, <br data-id="element-164" />
            що підкреслює вашу красу
          </h1>
          <p className="text-gray-600 text-lg md:text-xl mb-10 font-normal leading-relaxed" data-id="element-165">
            Повний спектр послуг: від стрижок та складного фарбування до
            манікюру та догляду.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-166">
            <a href="#contact" className="px-8 py-4 bg-dark text-white text-center text-sm font-medium tracking-wide hover:bg-black transition-colors" data-id="element-167">
              Записатися на послугу
            </a>
            <a href="#courses" className="px-8 py-4 border border-dark text-dark text-center text-sm font-medium tracking-wide hover:bg-gray-50 transition-colors" data-id="element-168">
              Дізнатися про курси
            </a>
          </div>

          <div className="grid grid-cols-3 gap-6 border-t border-gray-100 pt-8" data-id="element-169">
            <div data-id="element-170">
              <p className="font-heading text-4xl text-accent mb-1" data-id="element-171">12+</p>
              <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-172">
                Років досвіду
              </p>
            </div>
            <div data-id="element-173">
              <p className="font-heading text-4xl text-accent mb-1" data-id="element-174">5k+</p>
              <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-175">
                Задоволених клієнтів
              </p>
            </div>
            <div data-id="element-176">
              <p className="font-heading text-4xl text-accent mb-1" data-id="element-177">300+</p>
              <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-178">
                Випускників курсів
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative h-[600px] md:h-[800px] w-full" data-id="element-179">
          <div className="absolute inset-0 bg-[#F9F9F9] rounded-tl-[100px] rounded-br-[100px] overflow-hidden flex items-center justify-center border border-gray-100" data-id="element-180">
            <div className="text-center" data-id="element-181">
              <div className="w-16 h-16 mx-auto mb-4 border border-gray-200 rounded-full flex items-center justify-center" data-id="element-182">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-183">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-184"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5" data-id="element-185"></circle>
                  <polyline points="21 15 16 10 5 21" data-id="element-186"></polyline>
                </svg>
              </div>
              <p className="text-sm text-gray-400 font-light tracking-widest uppercase" data-id="element-187">
                Місце для фото
              </p>
            </div>
          </div>
          {/* Decorative element */}
          <div className="absolute -bottom-6 -left-6 w-32 h-32 border border-accent rounded-full opacity-50" data-id="element-188"></div>
          <div className="absolute -top-6 -right-6 w-24 h-24 border border-gray-300 rounded-full opacity-50" data-id="element-189"></div>
        </motion.div>
      </div>
    </section>;
}